import { IApiLink } from "@/types"
import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import DocumentCategory, { IGetDocumentCategoryDto } from "./DocumentCategory"

export interface IGetDocumentCategoriesDto {
    entities?: IGetDocumentCategoryDto[] | null
    links?: IApiLink[] | null
}

export default class DocumentCategories {
    items: DocumentCategory[]
    createLink?: IApiLink

    constructor(dto: IGetDocumentCategoriesDto) {
        this.items = dto.entities?.map(dcDTO => new DocumentCategory(dcDTO)) || []
        this.createLink = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.documentCategory && lnk.rel === ApiLinkRel.new)
    }
}
